import { Component, Vue, Prop } from 'vue-property-decorator'
import vSelect from 'vue-select'

@Component({
	components: {
		vSelect,
	},
	mixins: [],
})
export default class CalcSubjects extends Vue {
	@Prop() readonly propObject
	@Prop() readonly options

	optionsClassification = null
	savingOpSubject = false

	mounted() {
		if (!this.propObject.calc_subjects_classification) {
			Vue.set(this.propObject, 'calc_subjects_classification', {
				id: null,
			})
		}
	}

	addOpSubjectNew() {
		if (!this.propObject.opSubject) return
		const opSubject = this.options.opSubjects.find(
			(opSubject) => opSubject.id === this.propObject.opSubject,
		)

		this.propObject.opSubjects.push({
			name: opSubject.name,
			id: opSubject.id,
			loading: false,
		})
		this.propObject.opSubject = ''
	}

	async removeOpSubjectNew(index) {
		this.propObject.opSubjects.splice(index, 1)
	}
}
